import BaseApiClient from "@/api/base-client";
import { SortOption } from "@/types/external-content";
class ExternalContentApi extends BaseApiClient {
    BASE_PATH = "/api/studies";
    contentPath(studyId, activityId, contentId) {
        const base = `${this.BASE_PATH}/${studyId}/activities/${activityId}/external-content`;
        return contentId ? `${base}/${contentId}` : base;
    }
    getConfig = async (studyId, activityId) => {
        return this.get(`${this.contentPath(studyId, activityId)}/config`);
    };
    list = async (studyId, activityId, sort = SortOption.RECENT) => {
        const response = await this.get(this.contentPath(studyId, activityId), {
            params: { sort }
        });
        return response.contents;
    };
    create = async (studyId, activityId, data) => {
        return this.post(this.contentPath(studyId, activityId), { data });
    };
    remove = async (studyId, activityId, contentId) => {
        return this.delete(this.contentPath(studyId, activityId, contentId));
    };
    getById = async (studyId, activityId, contentId) => {
        return this.get(this.contentPath(studyId, activityId, contentId));
    };
    updateMetadata = async (studyId, activityId, contentId, data) => {
        return this.put(`${this.contentPath(studyId, activityId, contentId)}/metadata`, {
            data
        });
    };
    getTranscript = async (studyId, activityId, contentId, engine, exportMode) => {
        const params = {};
        if (engine)
            params.engine = engine;
        if (exportMode)
            params.export = true;
        return this.get(`${this.contentPath(studyId, activityId, contentId)}/transcript`, {
            params: Object.keys(params).length ? params : undefined
        });
    };
    acknowledgeLiveMinutes = async (studyId, activityId) => {
        return this.post(`${this.contentPath(studyId, activityId)}/live-minute-acknowledgment`);
    };
    /**
     * Sync activity start/end dates to encompass all content source dates.
     */
    syncDates = async (studyId, activityId) => {
        return this.put(`${this.contentPath(studyId, activityId)}/sync-dates`);
    };
    retranscribe = async (studyId, activityId, contentId) => {
        return this.post(`${this.contentPath(studyId, activityId, contentId)}/retranscribe`);
    };
    fetchSummary = async (studyId, activityId, contentId, exportMode) => {
        return this.get(`${this.contentPath(studyId, activityId, contentId)}/summaries`, {
            params: exportMode ? { export: true } : undefined
        });
    };
    regenerateSummary = async (studyId, activityId, contentId, contentType) => {
        return this.post(`${this.contentPath(studyId, activityId, contentId)}/summaries/${contentType}`);
    };
    static instance = new ExternalContentApi();
}
export default ExternalContentApi.instance;
